var React = require('react');

function Down (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.5957 0.547607L8.5957 37.7933","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M17.0903 30.0025L8.54528 38.5476L0.00022122 30.0025","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Down.defaultProps = {"width":"18","height":"40","viewBox":"0 0 18 40","fill":"none"};

module.exports = Down;

Down.default = Down;
